import types from '../../mutation-types';

export const mutations = {
  [types.SET_MESSAGES_UI_FLAG]($state, payload) {
    $state.uiFlags = { ...$state.uiFlags, ...payload };
  },
};
